<template>
  <div class="style">
    <div class="onehome">
      <van-icon @click='back' class="return" color="#fff" name="arrow-left" />
      <h3 class="title">服务</h3>
      <div class="imgbox">
        <van-icon name="chat-o" size='.6rem' color='#fff' @click='toModule("/personal/News")' />
        <van-icon name="scan" style="margin-left:6px" color="#fff" size='.6rem' @click='toScan' />
      </div>
    </div>
    <div class="wuye">
        <div class="titlef">
          <h3>在线物业</h3>
          <p @click='toModule("/property")'>查看全部<van-icon name="arrow" size='14px' /></p>
        </div>
    </div>
    <div class="wbox">
      <div>
        <img src="@/static/image/index/02.png" @click='toModule("/personal/Pay")' alt="">
        <a class="" href="http://tawy.yun.bsgoal.net.cn/q/ParkRenewals_Index_moduleId=3">
          <img src="@/static/image/index/03.png" alt="">
        </a>
        <router-link :to="`/propertyDetiles/${commonService.maintain}`">
          <img src="@/static/image/index/04.png" alt="">
        </router-link>
        <router-link :to="`/business/businessList/equipment/${commonService.advertisingPosition}`">
          <img src="@/static/image/index/05.png" alt="">
        </router-link>
        <router-link :to="`/business/businessList/equipment/${commonService.housecd}`">
          <img src="@/static/image/index/06.png" alt="">
        </router-link>
        <router-link :to="`/propertyDetiles/${commonService.houserz}`">
          <img src="@/static/image/index/07.png" alt="">
        </router-link>
      </div>
    </div>
    <div class="notice"></div>
    <div class="guangg">
      <van-swipe :autoplay="5000" indicator-color="white">
       <van-swipe-item><img src="@/static/image/index/pic1.jpg" alt="" @click='toModule("/qrcode/1000/3632")'></van-swipe-item>
        <van-swipe-item><img src="@/static/image/index/pic2.jpg" alt="" @click='toModule("/ExclusiveDetalis/1013")'></van-swipe-item>
        <van-swipe-item><img src="@/static/image/index/pic3.jpg" alt="" @click='toModule("/business/equipmentInfo/1149/1093")'></van-swipe-item>
        <van-swipe-item><img src="@/static/image/index/pic4.jpg" alt="" @click='toModule("/business/equipmentInfo/1150/1094")'></van-swipe-item>
      </van-swipe>
    </div>
    <div class="yuanq">
        <div class="titlef">
          <h3>商务服务</h3>
          <p @click="cur=0" :class="{active:cur==0}">广告位</p>
          <p @click="cur=1" :class="{active:cur==1}">周转仓</p>
          <p @click="cur=2" :class="{active:cur==2}">会议室</p>
        </div>
        <div class="tab-content">
            <div v-show="cur==0" @click="jumpDetails(activityList[0].serviceId,activityList[0].facilitiesId)">
              <img :src="activityList[0].banner">
              <p>{{activityList[0].title}}
                <span>¥{{activityList[0].price*0.01}}</span>
              </p>
              <span class="time"><van-icon name="underway-o" />{{activityList[0].createTime | DateFilter('yyyy-MM-dd')}}</span>
            </div>
            <div v-show="cur==1" @click="jumpDetails(welfareList[0].serviceId,welfareList[0].facilitiesId)">
              <img :src="welfareList[0].banner">
              <p>{{welfareList[0].title}}
                <span>¥{{welfareList[0].price*0.01}}</span>
              </p>
              <span class="time"><van-icon name="underway-o" />{{welfareList[0].createTime | DateFilter('yyyy-MM-dd')}}</span>
            </div>
            <div v-show="cur==2" @click='toModule(`/business/OfficeDetalis/${categoryList[0].id}`)'>
              <img :src="categoryList[0].roomPic">
              <p>{{categoryList[0].roomName}}
                <span>容纳{{categoryList[0].capacityNum}}人</span>
              </p>
              <span class="time"><van-icon name="underway-o" />{{categoryList[0].createTime | DateFilter('yyyy-MM-dd')}}</span>
            </div>
        </div>
    </div>
    <!-- <div class="notice"></div> -->
    <div class="there">
      <div class="titlebox titlef">
        <h3>第三方服务</h3>
      </div>
      <ul class="clearfix">
        <router-link :to="{ path: `/propertyDetiles/${item.serviceId}` }" v-for="(item,index) in serviceThere" :key="index">
          <li>
            <img :src="item.picUrl" alt="">
            <h3 class="textOver">{{ item.serviceName }}</h3>
          </li>
        </router-link>
      </ul>
    </div>
    <!-- 遮罩层播放视频 -->
    <div class="mask" v-show="maskFlag">
      <div class="content">
        <p @click="closeMask">X</p>
        <video :src="videoUrl" controls :autoplay="maskFlag">您的浏览器暂不支持播放该视频，请升级至最新版浏览器。</video>
      </div>
    </div>
    <div>
      <van-tabbar v-model="active">
        <van-tabbar-item :to="`/index?parkId=${this.currentParkId}`"><div class="divicon"><van-icon size='22px' name="wap-home" />首页</div></van-tabbar-item>
        <van-tabbar-item to="/propertys"><div class="divicon"><van-icon size='22px' name="like-o" />服务</div></van-tabbar-item>
        <van-tabbar-item :to="`${this.currentParkId == 1003||this.currentParkId == 1000||this.currentParkId == 1006?'/parkCompleteSet/foodCourt':'/humanResource/jobList'}`"><div class="divicon"><van-icon size='22px' name="location-o" />附近</div></van-tabbar-item>
        <van-tabbar-item to="/parkCompleteSet/ExclusiveActivities"><div class="divicon"><van-icon size='22px' name="point-gift-o" />活动</div></van-tabbar-item>
        <van-tabbar-item to="/personal"><div class="divicon"><van-icon size='22px' name="contact" />我的</div></van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { Tab, Tabs,Toast, DropdownMenu, DropdownItem, Search,Tabbar, TabbarItem } from 'vant';
import commonService from '@/static/commonService';


export default {
  data() {
    return {
      active: 1,
      cur:0, //默认选中第一个tab
      categoryList: [
        {
          roomPic : "1.jpg",
          roomName : "空",
          capacityNum : "0",
          createTime : "10000000",
        }
      ],
      activityList:[
        {
         banner : "1.jpg",
          title : "空",
          price : "0",
          createTime : "10000000",
        }
      ],
      welfareList:[
        {
          banner : "1.jpg",
          title : "空",
          price : "0",
          createTime : "10000000", 
        }
      ],
      serviceThere: [],
      maskFlag: false,
      videoUrl: null,
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
      commonService: {},
    }
  },
  methods: {
    ...mapMutations(['change_parkServiceList', 'change_currentParkId']),
    onChange(index) {
      // const videos = this.$el.querySelectorAll('#vanSwipe video');
      // videos.forEach((val) => {
      //   val.pause();
      // });
    },
    videoClick(src) {
      // 弹框播放视频
      this.maskFlag = true;
      this.videoUrl = src;
      document.body.style.overflow = 'hidden';
      // this.$el.querySelector(`#video${src}`).play();  // 点击播放视频
    },
    getSelected(value1){
      this.$router.push({ path: `index?parkId=${value1}`})
    },
    closeMask() {
      this.maskFlag = false;
      document.body.style.overflow = 'auto';
      this.$el.querySelector('.mask video').pause();
    },
    back(){
        this.$router.go(-1);//返回上一层
    },
    getServiceThere(flag) {  // 获取商务平台列表
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
        parkId: this.currentParkId,
        parentId: 1004,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.serviceThere = res.resData.pageList ? res.resData.pageList.slice(0,3) : [];
        }
      });
    },
    getList() {  // 会议室列表
      this.$http.post(`${this.URL_PREFIX}/app/get/meeting/room/info/list`, {
        parkId: this.currentParkId,
        currPage: 1,
        pageRows: 5,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.categoryList = res.resData.pageList ? res.resData.pageList.slice(0,1) : this.categoryList;
        }else{
          this.$toast(res.resDesc);
        }
      });
    },
    getactivityList() {  // 广告位
      this.$http.post(`${this.URL_PREFIX}/app/get/facilities/rent/list`, {
        parkId: this.currentParkId,
        serviceId: this.commonService.advertisingPosition,
        currPage: 1,
        pageRows: 4,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.activityList = res.resData.pageList ? res.resData.pageList.slice(0,1) : this.activityList;
          // console.log(this.activityList)
        }else{
          this.$toast(res.resDesc);
        }
      });
    },
    getwelfareList() {  // 周转仓获取列表
      this.$http.post(`${this.URL_PREFIX}/app/get/facilities/rent/list`, {
        parkId: this.currentParkId,
        serviceId: this.commonService.zromc,
        currPage: 1,
        pageRows: 4,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.welfareList = res.resData.pageList ? res.resData.pageList.slice(0,1) : this.welfareList;
        }else{
          this.$toast(res.resDesc);
        }
      });
    },
    jumpDetails(serviceId,index) {
      this.$router.push({ path: `/business/equipmentInfo/${serviceId}/${index}`})
    },
    toModule(path) {
      this.$router.push({ path: path });
    },
    toScan() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {

        this.getJsSdkConfigParams();
      }
    },
    // 获取微信扫码配置
    getJsSdkConfigParams() {
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
        url: location.href.split('#')[0]
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.scanConfig.appId = res.resData.appId;
          this.scanConfig.timestamp = res.resData.timestamp;
          this.scanConfig.nonceStr = res.resData.nonceStr;
          this.scanConfig.signature = res.resData.signature;
          this.config();
        } else {
          Toast.fail({ duration: 1500, message: res.resDesc });
        }
      });
    },
    // 扫码
    config() {
      wx.config({
        debug: false,
        appId: this.scanConfig.appId,
        timestamp: this.scanConfig.timestamp,
        nonceStr: this.scanConfig.nonceStr,
        signature: this.scanConfig.signature,
        jsApiList: ['checkJsApi', 'scanQRCode']
      });


      // 配置出错
      wx.error((res) => {
        Toast.fail({ duration: 1500, message: `${res.errMsg}` });
      });

      // 配置成功之后的回调
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList : ['scanQRCode'],
          success : (res) => {
          }
        });
        wx.scanQRCode({
          /**
           * 此处为0才能使用PC官网的扫一扫登陆功能
           * 因为微信的登陆二维码做了特殊处理，必须直接由微信扫码跳转过去才行
           * 例如把微信登陆二维码识别为文本url后再点击也是不行的，必须由微信直接扫码跳转（微信会识别来源方式）
           * 所以如果要兼容官网微信登陆功能，这里就无法由我们自行处理二维码内容
           */
          needResult : 0,
          scanType : ["qrCode"],
        });
      });
    },

    commingSoon(){
      Toast('内容丰富中，敬请期待');
    },
  },
  created() {
    if(this.$route.query.parkId){
      this.change_currentParkId(Number(this.$route.query.parkId));
    }
    this.commonService = commonService[process.env.commonServiceConfKey][this.currentParkId];
  },
  mounted() {
    this.getList();
    this.getwelfareList();
    this.getactivityList();
    this.getServiceThere();
  },
  computed: {
    ...mapGetters(['currentParkId', 'token']),
  },
  watch: {
    $route() {
      this.getList();
      this.getwelfareList();
      this.getactivityList();
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.style {
  background-color: #fff;
}
.divicon{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  i{
    padding-bottom: .1rem;
  }
}
.onehome{
  background: #205eff;
  width: 100%;
  height: 1.2rem;
  display: flex;
  justify-content:space-between;
  align-items: center;
  .return{
    padding-left: .18rem;
  }
  .title{
    text-align: center;
    color: #fff;
    padding-left: .88rem;
  }
  .imgbox{
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: .18rem;
  }
}

.huod{
  background: #fff;
  width: 100%;
  height: 4rem;
  display: flex;
  justify-content: center;
  flex-direction:column ;
  padding: .4rem 0 .8rem 0;
    margin-bottom: px2rem(60);
  img{
    // width: 94%;
    // height: 100%;
    height: 3.2rem;
    object-fit: cover;
    border-radius: 6px;
    margin: 0 auto;
  }
  h3{
    margin: .2rem 0;
    padding-left: 0.24rem;
  }
  p{
    padding-left: 0.24rem;
    font-size: px2rem(26);
    color: #949fa6;
  }
}

.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0,0,0,.8);
  .content {
    position: absolute;
    border-radius: 4px;
    top: 4rem;
    left: 0;
    right: 0;
    bottom: 4rem;
    // margin: 20px;
    background-color: #fff;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    p {
      height: 1rem;
      line-height: 1rem;
      text-align: right;
      padding-right: 20px;
      font-size: .5rem;
    }
    video {
      flex: 1;
      width: 100%;
      cursor: pointer;
    }
  }
}
.guangg{
  height: px2rem(260);
  padding: .1rem .4rem;
  img{
  border-radius: .18rem;
  }

  .van-swipe{
  padding-top: px2rem(15);
  }

}
.van-swipe {
  height: px2rem(230);
  position: relative;
  .van-swipe-item {
    // background-color: #000;
    display: flex;
    align-items: center;
    img{
      object-fit: cover;
    }
    .playVideo {
      position: absolute;
      width: 1.066667rem;
      height: 1.066667rem;
      // background-color: rgba(0,0,0,.8);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        color: #fff;
        font-size: 1.066667rem;
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
  video {
    width: 100%;
    height: 100%;
    background-color: #000;
  }
}
nav {
  display: flex;
  height: 5.206667rem;
  justify-content: space-around;
  flex-wrap: wrap;
  .entry {
    // flex: 1;
    width: 2.16rem;
    padding-top: .386667rem;
    .icon {
      width: 1.38rem;
      height: 1.26rem;
      margin: 0 auto;
      .iconfont {
        font-size: .72rem;
      }
    }
    h3 {
      font-size: .363333rem;
      line-height: 1rem;
      text-align: center;
    }
  }
}
.notice {
  padding-bottom: px2rem(24);
  background-color: rgb(245, 245, 245);
}
.fangy {
  padding-bottom: px2rem(24);
  background-color: rgb(245, 245, 245);
  .titlef{
    background: #fff;
    display: flex;
    justify-content:flex-start;
    padding: px2rem(24) px2rem(36);
    h3{
      border-left:4px solid #288ff8;
      padding-left: px2rem(18);
      font-weight: 600;
      height: 0.49rem;
      line-height: .49rem;
    }
    p{
      font-size: px2rem(26);
      color: #949fa6;
    }
  }
  .fcont{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    background: #fff;
    padding: px2rem(16);
    .fbox{
      height: 3.05333rem;
      line-height: 1;
      width: 4.25333rem;
      margin: 0.12rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      position: relative;
      box-shadow: 2px 2px 6px #bcbcb2;
      border-radius: 0.2rem;
      img{
        border-radius: 0.2rem 0.2rem 0 0;
      }
      .textOver{
        text-align: center;
        font-size: .386rem;
      }
    }
  }
}
.yuanq{
  height: 6.6889rem;
  // padding: .1rem .4rem;
  // padding-bottom: px2rem(24);
  background-color: rgb(245, 245, 245);
  display: flex;
  justify-content: center;
  flex-direction:column ;
  .titlef{
  background: #fff;
  display: flex;
  justify-content:flex-start;
  padding: px2rem(24);
  padding-bottom: .32rem;
  align-items: flex-end;
    h3{
      border-left:4px solid #288ff8;
      padding-left: px2rem(18);
      font-weight: 600;
      height: 0.49rem;
      line-height: .49rem;
    }
    p{
      font-size: px2rem(26);
      color: #949fa6;
      margin-left: .28rem;
    }
    .active{
      color: #000;
      // font-size: .38rem;
    }
  }
  .tab-content{
    padding: .1rem .4rem;
    background: #fff;
    img{
      height: 3rem;
      width:100%;
      object-fit: cover;
      border-radius: .18rem;
    }
    p{
      padding: .2rem 0;
      display: flex;
      justify-content: space-between;
      font-size: .46rem;
      span{
        color: #e82020;
      }
    }
    .time{
      color: #827474;
      display: flex;
      align-items: center;
      padding-bottom: .2rem;
      i{
        margin-right: .12rem;
      }
    }

  }
  
}
.there{
  background-color: rgb(245, 245, 245);
  display: flex;
  justify-content: center;
  flex-direction:column ;
  padding-bottom: 1.66rem;
  .titlef{
  background: #fff;
  display: flex;
  justify-content:flex-start;
  padding: px2rem(24);
  padding-bottom: .32rem;
  align-items: flex-end;
    h3{
      border-left:4px solid #288ff8;
      padding-left: px2rem(18);
      font-weight: 600;
      height: 0.49rem;
      line-height: .49rem;
    }
    p{
      font-size: px2rem(26);
      color: #949fa6;
      margin-left: .28rem;
    }
}
.clearfix{
  // height: 3.8rem;
  padding: .1rem .4rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  a{
    float: left;
    display: block;
    height: 100%;
    width: 30%;
    padding-bottom: .2rem;
      li{
        box-shadow: 2px 2px 6px #bcbcb2;
        padding-bottom: .2rem;
        border-radius: .2rem;
        img{
          width: 100%;
          height: 1.8rem;
          object-fit: cover;
          border-radius: .2rem;
        }
        h3{
          text-align: center;
        }
      }
  }
}
}
.wuye{
  height: 3.2889rem;
  padding-bottom: px2rem(24);
  background-color: #205eff;
  display: flex;
  flex-direction:column ;
  .titlef{
  background: #205eff;
  display: flex;
  justify-content:space-between;
  padding: px2rem(24);
  padding-bottom: .32rem;
    h3{
      border-left:4px solid #fff;
      padding-left: px2rem(18);
      color: #fff;
      font-weight: 600;
      height: 0.49rem;
      line-height: .49rem;
    }
    p{
      font-size: px2rem(26);
      color: #fff;
      display: flex;
      align-items: center;
    }
  }
  
}
.wbox{
  // height: 7.8rem;
  width: 88%;
  margin: 0 auto;
  background: #fff;
  border-radius: .36rem;
  margin-top: -2.3rem;
  margin-bottom: .386rem;
  display: flex;
  justify-content: center;
  div{
    padding-top: .4rem;
    width: 92%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap:wrap;
    align-items: center;
    a{
      width: 46%;
      margin: .1rem 0;
      img{
        width: 100%;
      }
    }
    img{
      width: 46%;
      margin: .1rem 0;
    }
  }
}
.service {
  padding: px2rem(40) px2rem(24) px2rem(24);
  h3 {
    font-size: px2rem(32);
    font-weight: bold;
    line-height: 1;
  }
  .shortcut-list{
    display: flex;
    justify-content: space-around;
    margin-top: px2rem(30);
    margin-bottom: px2rem(80);
    .shortcut{
      display: flex;
      align-items: center;
      flex-flow: column;
      .icon{
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #EBEBEB;
        border-radius: 50%;
        width: px2rem(100);
        height: px2rem(100);
        img{
          width: px2rem(80);
          height: px2rem(80);
        }
      }
      .title{
        margin-top: px2rem(20);
        font-size: px2rem(24);
        line-height: 1;
        color: #333;
      }
    }
  }
  .content{
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .item{
      height: px2rem(214);
      padding: px2rem(28) px2rem(30);
      line-height: 1;
      width: 49%;
      margin-bottom: px2rem(6);
      box-sizing: border-box;
      position: relative;
      .title{
        font-size: px2rem(30);
      }
      .desc{
        margin-top: px2rem(20);
        font-size: px2rem(22);
        color: #666;
      }
      .icon{
        position: absolute;
        right: px2rem(40);
        bottom: px2rem(12);
        max-height: px2rem(80);
      }
    }
  }
  .test{
    width: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/property/Propertys.vue